// extracted by mini-css-extract-plugin
export default {"magicItemCroutonIcon":"zXEnbl"};